module.exports = __webpack_public_path__ + "img/3.358a8516.jpg";